module.exports = __webpack_public_path__ + "img/signedCircle.c65ca51c.svg";